// ** IMPORTANT **: Keep in sync with functions/src/index.ts
export enum IMAGE_METADATA_PROCESSING_MODE {
    minimal = 'minimal',
    standard = 'standard',
    full = 'full',
}
